import { z } from "zod";
import { isValidPhoneNumber } from "react-phone-number-input";

export type TranslationFunction = (key: string) => string;

/**
 * Common validation schemas that can be reused across forms
 */
export const createCommonSchemas = (t: TranslationFunction) => ({
  name: z.string()
    .min(1, t("Name is required"))
    .min(2, t("Name must be at least 2 characters"))
    .refine((val) => val.trim().length >= 2, t("Name must be at least 2 characters")),
  
  email: z.string()
    .min(1, t("Email is required"))
    .email(t("Please enter a valid email")),
  
  phone: z.string()
    .optional()
    .refine((val) => !val || isValidPhoneNumber(val), t("Please enter a valid phone number")),
  
  requiredString: (minLength = 1) => z.string()
    .min(1, t("This field is required"))
    .refine((val) => val.trim().length >= minLength, t(`This field must be at least ${minLength} characters`)),
});

